import { AppModule } from 'app/module';
import { ProposalList } from 'module/proposalList/main';
import Template from './template.hbs';
import './styles.scss';

export class JobsProposals extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            proposalList: '.m-proposalList',
        };
    }

    subs() {
        if (this.dom.proposalList) {
            this.proposalList = new ProposalList(this.dom.proposalList);
        }
    }

    subEvents() {
        this.propagateEvents(this.proposalList, 'proposalLinkClicked');
    }
}
